export const BATCH_UPLOAD_LOG_PAGE_1_QUERY_KEY = ['batchUploadLog', 'rider', 1];
export const SHOULD_POLL_UPLOAD_LOG_KEY = ['batchUploadLog', 'rider', 'shouldPoll'];
